import React from 'react'

interface CategoryProps {
  categories: { edges: [] } | Blog.Categories | undefined
}

export default function Categories({ categories }: CategoryProps) {
  return (
    <div className='flex items-center space-x-2'>
      {categories?.edges?.map(category => (
        <span
          key={category.node.name}
          className='inline-flex items-center rounded-md bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-800'
        >
          {category.node.name}
        </span>
      ))}
    </div>
  )
}
